var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "knowledge-center-new dashboard-card dashboard-card-lt mt-4"
  }, [_c('div', {
    staticClass: "knowledge_head"
  }, [_c('div', {
    staticClass: "d-flex dashboard-knowledge-title align-items-center justify-content-between"
  }, [_c('h3', [_vm._v("Knowledge Center")]), _c('button', {
    staticClass: "view-all-knowledge",
    on: {
      "click": function () {
        return _vm.$router.push({
          name: 'ViewKnowledge'
        });
      }
    }
  }, [_vm._v(" View All ")])])]), _vm.skeletonLoader ? _c('b-skeleton-table', {
    attrs: {
      "rows": 5,
      "columns": 2,
      "table-props": {
        bordered: true,
        striped: true
      }
    }
  }) : _vm._e(), !_vm.skeletonLoader ? _c('div', {
    staticClass: "dashboard-knowledge-body"
  }, [_vm.checkRowLength() ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v(" No results found ")]) : _vm._e(), _c('ul', {
    staticClass: "knowledge-preview-list"
  }, [_vm._l(_vm.knowledge_feeds.slice(0, 10), function (item, index) {
    return [_c('li', {
      key: index,
      staticClass: "knowledge-item",
      on: {
        "click": function ($event) {
          return _vm.$bvModal.show('knowledge_modal_' + item.id);
        }
      }
    }, [_vm._m(0, true), _c('div', {
      staticClass: "knowledge-content"
    }, [_c('div', {
      staticClass: "knowledge-title"
    }, [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "knowledge-meta text-end"
    }, [_c('div', {
      staticClass: "knowledge-author"
    }, [_vm._v(_vm._s(item.source))]), _c('div', {
      staticClass: "knowledge-date"
    }, [_vm._v(_vm._s(item.published_date))])])]), index < _vm.knowledge_feeds.slice(0, 10).length - 1 ? _c('hr', {
      key: index,
      staticClass: "knowledge-item-ruler"
    }) : _vm._e()];
  })], 2)]) : _vm._e(), _vm._l(_vm.knowledge_feeds, function (item, index) {
    var _item$created_user$ag, _item$created_user, _item$created_user$re, _item$created_user2;
    return _c('b-modal', {
      key: index,
      staticClass: "message_modal new_one",
      attrs: {
        "title": item.title,
        "id": 'knowledge_modal_' + item.id,
        "centered": true,
        "hide-footer": true,
        "size": "lg"
      }
    }, [_c('div', {
      staticClass: "modal-body"
    }, [_c('div', {
      staticClass: "rcv-msgcontent"
    }, [_c('div', {
      staticClass: "rcv-msg-sender"
    }, [_c('div', {
      staticClass: "rcv-snder-icon"
    }, [_c('img', {
      staticClass: "msg-userIcon",
      attrs: {
        "src": (_item$created_user$ag = item === null || item === void 0 ? void 0 : (_item$created_user = item.created_user) === null || _item$created_user === void 0 ? void 0 : _item$created_user.agent_profile_image) !== null && _item$created_user$ag !== void 0 ? _item$created_user$ag : _vm.$dummyImage,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "rcv-sender-details"
    }, [_c('h6', [_vm._v(_vm._s((_item$created_user$re = item === null || item === void 0 ? void 0 : (_item$created_user2 = item.created_user) === null || _item$created_user2 === void 0 ? void 0 : _item$created_user2.rep_full_name) !== null && _item$created_user$re !== void 0 ? _item$created_user$re : "ADMIN"))]), _c('p', [_c('i', {
      staticClass: "far fa-calendar-alt"
    }), _vm._v(" " + _vm._s(_vm._f("date_format")(item.published_date, "YYYY-MM-DD", "MM/DD/YYYY", item.published_date)) + " ")])])])]), _c('h5', [_vm._v("Title: " + _vm._s(item.title))]), _c('hr'), _c('div', {
      staticClass: "ql-snow"
    }, [_c('div', {
      staticClass: "ql-editor"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })])]), item.file && item.file.length > 0 ? _c('div', [_c('h6', [_vm._v("Attachments:")]), _c('ul', {
      staticStyle: {
        "list-style": "none"
      }
    }, _vm._l(item.file, function (file) {
      return _c('li', {
        key: file.id
      }, [_c('a', {
        attrs: {
          "href": file.path,
          "target": "__blank",
          "download": ""
        }
      }, [_c('i', {
        staticClass: "fa fa-file"
      }), _vm._v(" " + _vm._s(file.filename) + " ")])]);
    }), 0)]) : _vm._e()])]), _c('div', {
      staticClass: "modal-footer"
    })]);
  })], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "knowledge-icon"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/message-icon.svg"),
      "alt": "Knowledge Icon"
    }
  })]);

}]

export { render, staticRenderFns }